import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Layout from './components/Layout';
import Home from './components/Home';
import ContactUs from './components/ContactUs';
import DonationList from './components/DonationList';
import ObservershipForm from './components/ObservershipForm';
import ScholarShipForm from './components/ScholarshipForm';
import Signup from './components/Signup';
import SignIn from './components/SignIn';
import ResetPassword from './components/ResetPassword';
import InternshipResearchForm from './components/InternshipResearchForm';
import ScholarshipProgram from './components/ScholarshipProgram';
import AcademicResearchForm from './components/AcademicResearchForm';
import LaboratoryTourForm from './components/LaboratoryTourForm';
import ProfilePage from './components/ProfilePage';
import ChangePassword from './components/ChangePassword';
import Success from './components/Success';
import Stories from './components/Stories';
import Testimonials from './components/Testimonials';
import ObservershipProgram from './components/ObservershipProgram';
import LaboratoryTour from './components/LaboratoryTour';
import AcademicResearch from './components/AcdemicResearch';
import InternshipResearchProgram from './components/InternshipResearchProgram';
import MedEngageSummit1819 from "./components/MedEngageSummit18_19";
import MedEngageSummit2122 from "./components/MedEngageSummit21_22";
import MedEngageSummit2223 from "./components/MedEngageSummit22_23";
import MedEngageSummit2324 from "./components/MedEngageSummit23_24";
import MedEngageSummit2021 from "./components/MedEngageSummit2021";
import BuildingKnowledgeCommunity from "./components/BuildingknowledgeCommunity";
import Winner from "./components/winner";
import Popup from './components/Popup';

const App = () => {
  return (
    <div>
    <Router>
        <Routes>
          {/* Auth routes outside layout */}
          <Route path="/Signup" element={<Signup />} />
          <Route path="/Signin" element={<SignIn />} />

          {/* Routes wrapped in Layout */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            {/* Main program pages */}
            <Route path="/about-us" element={<Home />} />{" "}
            {/* Assuming this is a section on home */}
            <Route
              path="/scholarship-program"
              element={<ScholarshipProgram />}
            />
            <Route
              path="/observership-program"
              element={<ObservershipProgram />}
            />
            <Route path="/laboratory-tour" element={<LaboratoryTour />} />
            <Route
              path="/building-knowledge-community"
              element={<BuildingKnowledgeCommunity />}
            />
            <Route
              path="/academic-research-support"
              element={<AcademicResearch />}
            />
            <Route
              path="/internship-program"
              element={<InternshipResearchProgram />}
            />
            {/* Summit pages */}
            <Route path="/summit-2018" element={<MedEngageSummit1819 />} />
            <Route path="/summit-2021" element={<MedEngageSummit2021 />} />
            <Route path="/summit-2022" element={<MedEngageSummit2122 />} />
            <Route path="/summit-2023" element={<MedEngageSummit2223 />} />
            <Route path="/summit-2024" element={<MedEngageSummit2324 />} />
            {/* Stories and testimonials */}
            <Route path="/stories" element={<Stories />} />
            <Route path="/testimonials" element={<Testimonials />} />
            {/* Contact */}
            <Route path="/contact-us" element={<ContactUs />} />
            {/* Application forms */}
            <Route
              path="/scholarship-application"
              element={<ScholarShipForm />}
            />
            <Route
              path="/observership-application"
              element={<ObservershipForm />}
            />
            <Route
              path="/laboratory-tour-application"
              element={<LaboratoryTourForm />}
            />
            <Route
              path="/academic-research-application"
              element={<AcademicResearchForm />}
            />
            <Route
              path="/internship-application"
              element={<InternshipResearchForm />}
            />
            {/* Other existing routes */}
            <Route path="/DonationList" element={<DonationList />} />
            <Route path="/ChangePassword" element={<ChangePassword />} />
            <Route path="/profile/" element={<ProfilePage />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/success" element={<Success />} />
            <Route path="/popup" element={<Popup />} />
            <Route path="/winners-2023-24" element={<Winner />} />
            {/* Preserve legacy routes temporarily for backward compatibility */}
            <Route
              path="/observershipprogramform"
              element={<ObservershipForm />}
            />
            <Route path="/scholarshipform" element={<ScholarShipForm />} />
            <Route
              path="/InternshipResearchForm"
              element={<InternshipResearchForm />}
            />
            <Route
              path="/laboratorytourForm"
              element={<LaboratoryTourForm />}
            />
            <Route
              path="/AcademicResearchForm"
              element={<AcademicResearchForm />}
            />
          </Route>
        </Routes>
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        className="custom-toast-container"
      />

      {/* Custom styles */}
      <style jsx global>{`
        .custom-toast-container {
          position: fixed !important;
          top: 80px !important;
          right: 20px !important;
          z-index: 9999 !important;
          width: auto !important;
          max-width: 400px !important;
        }
        .Toastify {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          pointer-events: none !important;
        }
        .Toastify__toast {
          pointer-events: auto !important;
        }
      `}</style>
    </div>
  );
};

export default App;
